import { defineModule } from '../../engine/module';
import { SchedulePanel } from './SchedulePanel';

// The scheduling UI (docs/servicedesk-v2-proposal.md P3). The diary itself is an engine calendar
// screen — appointments are a resource with a start and an end, which is exactly what the generic
// calendar view renders — so the only bespoke piece is the booking panel on the ticket.

export { SchedulePanel } from './SchedulePanel';

export const schedulingModule = defineModule({
  name: 'scheduling',
  nav: [
    {
      label: 'Service desk',
      order: 15,
      items: [{ label: 'Diary', to: '/appointments', icon: 'calendar', key: 'c' }],
    },
  ],
  screens: [
    {
      path: '/appointments',
      resource: 'appointments',
      kind: 'calendar',
      title: 'Diary',
      subtitle: 'Everything booked — remote sessions, callbacks and on-site visits.',
      calendar: { dateField: 'starts_at', endField: 'ends_at', labelField: 'subject' },
      query: { sort: 'starts_at' },
      detailPath: '/appointments/:id',
    },
    {
      path: '/appointments/:id',
      resource: 'appointments',
      kind: 'detail',
      builtinTabs: ['overview', 'activity'],
    },
    {
      path: '/appointment-types',
      resource: 'appointment-types',
      kind: 'list',
      title: 'Appointment types',
      subtitle: 'What a client can book: duration, buffers, notice, horizon — and what booking does to the ticket.',
      columns: ['name', 'key', 'duration_minutes', 'location', 'buffer_after_minutes', 'min_notice_minutes', 'max_days_ahead', 'is_active'],
      detailPath: '/appointment-types/:id',
      inspector: true,
    },
    {
      path: '/appointment-types/:id',
      resource: 'appointment-types',
      kind: 'detail',
      builtinTabs: ['overview', 'activity'],
      tabs: [{ key: 'members', label: 'Who can be booked', icon: 'users', resource: 'appointment-type-members', filter: { type_id: ':id' }, columns: ['technician_id', 'sort'] }],
    },
    {
      path: '/booking-requests',
      resource: 'booking-requests',
      kind: 'list',
      title: 'Booking links',
      subtitle: 'Invitations sent, opened and used — an unanswered link is a customer still waiting.',
      columns: ['status', 'type_id', 'ticket_id', 'sent_to_email', 'viewed_at', 'booked_at', 'expires_at', 'created_at'],
      filters: [{ field: 'status', kind: 'chips' }],
      query: { sort: '-created_at' },
      create: false,
      hidden: true,
    },
  ],
  widgets: { schedulePanel: SchedulePanel },
  commands: [
    { id: 'sched-diary', label: 'Diary', kind: 'go to', icon: 'calendar', keywords: 'appointments calendar schedule booked', run: ({ navigate }) => navigate('/appointments') },
    { id: 'sched-links', label: 'Booking links', kind: 'go to', icon: 'link', keywords: 'invitation self schedule timezest', run: ({ navigate }) => navigate('/booking-requests') },
  ],
});
